import React, { Component } from 'react'
import { Link } from 'react-router-dom'
import { connect } from 'react-redux'
import moment from 'moment'
import * as actions from '../../containers/deals/actions'
import { routePrefix } from '../../config'
import './styles.css'
import TablePagination from '../../components/common/tablePagination'
import backArrow from '../../images/back-arrow.svg'

class AuditDeals extends Component {
	state = {
		merchantId: '',
		isAudit: false,
		pageNum: 1,
		paginationLimit: 10 //change this to whatever number of entries needed in table.
	}

	componentDidMount() {
		const provider_id = this.props.allRoutesInfo.provider_id || localStorage.getItem('provider-id');
		const operator_id = this.props.allRoutesInfo.operator_id || localStorage.getItem('operator-id');
		this.date = moment().format('YYYY-MM-DD');
		this.props.fetchAuditDealData(provider_id, operator_id, this.date);
	}

	onPrevClick = () => {
		this.setState({ pageNum: this.state.pageNum - 1 });
	}

	onNextClick = () => {
		const { auditDealData } = this.props;
		const { pageNum, paginationLimit } = this.state;
		// if page data is available just increase the page num count
		const dealsAuditList = auditDealData && auditDealData.deal_activity;
		if (dealsAuditList && dealsAuditList.length > pageNum * paginationLimit) {
			this.setState({ pageNum: pageNum + 1 });
			return;
		}
	}

	render() {
		const { auditDealData } = this.props;
		const { pageNum, paginationLimit } = this.state;
		const deal_activity = auditDealData && auditDealData.deal_activity;
		const dealsAuditList = deal_activity && deal_activity.slice().reverse();
		let startIndex = (pageNum - 1) * paginationLimit;
		let endIndex = (pageNum) * paginationLimit;
		return (
			<div className="payout">
				<div className="auditHeader">
					<Link to={routePrefix + '/deals'}>
						<div className="headerLhs">
							<img className="backIcon" src={backArrow} alt="icon" onClick={this.onAuditBackClick} />
							<span className="logText">Activity Tracker</span>
						</div>
					</Link>
					<div className="headerRhs">
						<span className="duration">Duration</span>
						<div className="durationText">Last 45 Days</div>
					</div>
				</div>
				<div className="payout-content">
					<TablePagination
						pageNum={pageNum}
						dataLength={dealsAuditList && dealsAuditList.length}
						onPrevClick={this.onPrevClick}
						onNextClick={this.onNextClick}
						paginationLimit={paginationLimit}
					/>
					<table className="app-table">
						<thead>
							<tr className="payout-table-header">
								<th className="tableSlNo">No</th>
								<th>User ID</th>
								<th>Deal</th>
								<th>Deal ID</th>
								<th>Action Taken</th>
								<th>Date and Time</th>
							</tr>
						</thead>
						<tbody>
							{
								auditDealData && !auditDealData.deal_activity && <tr><td colSpan={9} className="table-no-data">No Data Found</td></tr>
							}
							{
								dealsAuditList && dealsAuditList.slice(startIndex, endIndex).map((el, i) => (
									<tr key={i} className="payout-table-row">
										<td>{i + (startIndex + 1)}</td>
										<td>{el.updated_by.email_id}</td>
										<td>{el.deal_name}</td>
										<td>{el.deal_id}</td>
										<td> {el.action_performed}</td>
										<td> {moment.utc(el.timestamp).format('DD MMMM YYYY, h:mm:ss')}</td>
									</tr>
								))
							}
						</tbody>
					</table>
				</div>
			</div>
		)
	}
}

const mapStateToProps = store => ({
	dealsList: store.dealsReducer.dealsList,
	allRoutesInfo: store.userInfoReducer.allRoutesInfo,
	auditDealData: store.dealsReducer.auditDealData,
})

const mapDispatchToProps = dispatch => ({
	getOperatorDealsList: (merchantId) => dispatch(actions.getOperatorDealsList(merchantId)),
	updateDealStatus: (data, query, callback) => dispatch(actions.updateDealStatus(data, query, callback)),
	refreshDeal: (payload, query) => dispatch(actions.refreshDeal(payload, query)),
	fetchAuditDealData: (providerid, operatorid, date) => dispatch(actions.fetchAuditDealData(providerid, operatorid, date)),
})

AuditDeals.propTypes = {}

export default connect(mapStateToProps, mapDispatchToProps)(AuditDeals)